export const OnfidoTranslations = {
	deu: {
		locale: "de",
		phrases: {
			welcome: {
				title: "Ein neues Konto erstellen",
				description_p_1: "Um ein Konto zu erstellen, müssen wir deine Identität verifizieren.",
				description_p_2: "Das dauert nur ein paar Minuten.",
				next_button: "Identität verifizieren"
			},
			document_selector: {
				identity: {
					title: "Deine Identität verifizieren",
					hint: "Wähle die Art von Dokument aus, die du hochladen möchtest",
					passport_hint: "Zeige die Seite mit dem Foto",
					driving_licence_hint: "Die Vorder- und Rückseite",
					national_identity_card_hint: "Die Vorder- und Rückseite"
				},
				proof_of_address: {
					title: "%{country} Dokument wählen",
					hint: "Diese Dokumente enthalten höchstwahrscheinlich deine aktuelle Adresse",
					estatements_accepted: "Online-Auszüge akzeptiert",
					utility_bill_hint: "Gas, Strom, Wasser, Festnetz, oder Breitband",
					utility_bill_warning: "Leider keine Handyrechnungen",
					benefits_letter_hint:
						"Staatliche Leistungen wie Arbeitslosengeld, Wohnbeihilfe, Steuergutschriften etc.",
					government_letter_hint:
						"Jedes von einer staatlichen Institution ausgestellte Schreiben, z.B. Leistungsansprüche, Wahlkarten, Steuerbriefe, etc."
				}
			},
			capture: {
				driving_licence: {
					front: {
						title: "Führerschein hochladen (Vorderseite)",
						instructions: "Lade die Vorderseite deines Führerscheins von deinem Computer hoch",
						webcam: "Positioniere die Vorderseite deines Führerscheins in den Rahmen (Automatische Erkennung)"
					},
					back: {
						title: "Führerschein hochladen (Rückseite)",
						instructions: "Lade die Rückseite deines Führerscheins von deinem Computer hoch",
						webcam: "Positioniere die Rückseite deines Führerscheins innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				national_identity_card: {
					front: {
						title: "Ausweis hochladen (Vorderseite)",
						instructions: "Lade die Vorderseite deines Ausweises von deinem Computer hoch",
						webcam: "Positioniere die Vorderseite deines Ausweises innerhalb des Rahmens (Automatische Erkennung)"
					},
					back: {
						title: "Ausweis hochladen (Rückseite)",
						instructions: "Lade die Rückseite deines Ausweises von deinem Computer hoch",
						webcam: "Positioniere die Rückseite deines Ausweises innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				passport: {
					front: {
						title: "Fotoseite des Reisepasses hochladen",
						instructions: "Lade die Fotoseite deines Reisepasses von deinem Computer hoch",
						webcam: "Positioniere die Fotoseite deines Reisepasses innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				bank_building_society_statement: {
					front: {
						title: "Auszug hochladen",
						sub_title: "Darf nicht älter als <strong>3 Monate</strong> sein",
						instructions: "Für ein gutes Ergebnis das gesamte Dokument hochladen",
						webcam: "Positioniere deinen Kontoauszug innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				utility_bill: {
					front: {
						title: "Rechnung hochladen",
						sub_title: "Darf nicht älter als <strong>3 Monate</strong> sein",
						instructions: "Für ein gutes Ergebnis das gesamte Dokument hochladen",
						webcam: "Positioniere deine Betriebskostenabrechnung innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				benefit_letters: {
					front: {
						title: "Brief hochladen",
						sub_title: "Darf nicht älter als <strong>12 Monate</strong> sein",
						instructions: "Für ein gutes Ergebnis das gesamte Dokument hochladen",
						webcam: "Positioniere deinen Brief über den Leistungsanspruch innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				council_tax: {
					front: {
						title: "Brief hochladen",
						sub_title: "Darf nicht älter als <strong>12 Monate</strong> sein",
						instructions: "Für ein gutes Ergebnis das gesamte Dokument hochladen",
						webcam: "Positioniere den Brief des Finanzamts innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				government_letter: {
					front: {
						title: "Brief einer staatlichen Institution",
						sub_title: "Darf nicht älter als <strong>12 Monate</strong> sein",
						instructions: "Für ein gutes Ergebnis das gesamte Dokument hochladen",
						webcam: "Positioniere den Brief der staatlichen Institution innerhalb des Rahmens (Automatische Erkennung)"
					}
				},
				face: {
					title: "Selfie machen",
					upload_title: "Selfie",
					instructions: "Lade das Selfie von deinem Computer hoch",
					intro: {
						title: "Selfie machen",
						subtitle: "Wir werden es mit deinem Dokument vergleichen",
						selfie_instruction:
							"Schaue nach vorne und stelle sicher, dass deine Augen deutlich zu sehen sind",
						glasses_instruction: "Nimm deine Brille ab, falls du eine trägst",
						accessibility: {
							selfie_capture_tips: "Tipps für ein gutes Selfie"
						}
					}
				},
				liveness: {
					start: "Start",
					stop: "Stopp",
					recording: "Aufnahme",
					press_record: "Drücke auf die Aufnahmetaste und folge der Anleitung",
					intro: {
						title: "Stellen wir sicher, dass sich niemand als du ausgibt",
						two_actions:
							"Wir werden dich bitten, dich beim Ausüben <strong>zweier einfacher Handlungen</strong> aufzunehmen",
						speak_out_loud: "Eine davon ist <strong>lautes Sprechen</strong>",
						continue: "Weiter"
					},
					challenges: {
						position_face: "Positioniere dein Gesicht innerhalb der ovalen Form",
						recite: "Sprich jede Ziffer laut aus",
						movement: "Schaue über deine %{side} Schulter",
						right: "rechte",
						left: "linke",
						done_next: "Klicke auf weiter, wenn du fertig bist",
						done_stop: "Klicke auf Stopp, wenn du fertig bist",
						next: "Weiter"
					}
				},
				upload_document: "Hochladen",
				upload_file: "oder Foto hochladen – Keine Scans oder Kopien",
				take_photo: "Foto machen",
				switch_device: "Mache am Handy weiter"
			},
			confirm: {
				document: {
					title: "Lesbarkeit prüfen",
					alt: "Foto deines Dokuments"
				},
				driving_licence: {
					message:
						"Stelle sicher, dass die Daten auf deinem Führerschein deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				national_identity_card: {
					message:
						"Stelle sicher, dass die Daten auf deinem Ausweis deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				passport: {
					message:
						"Stelle sicher, dass die Daten auf deinem Reisepass deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				bank_building_society_statement: {
					message:
						"Stelle sicher, dass die Daten deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				utility_bill: {
					message:
						"Stelle sicher, dass die Daten deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				benefit_letters: {
					message:
						"Stelle sicher, dass die Daten deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				council_tax: {
					message:
						"Stelle sicher, dass die Daten deutlich lesbar sind und das Bild nicht verschwommen oder überbelichtet ist"
				},
				face: {
					standard: {
						title: "Selfie überprüfen",
						message: "Stelle sicher, dass dein Gesicht auf dem Selfie gut erkennbar ist",
						alt: "Bild von deinem Gesicht"
					},
					video: {
						title: "Selfie Video überprüfen"
					}
				},
				confirm: "Bestätigen",
				continue: "Weiter",
				redo: "Noch einmal",
				enlarge_image: {
					enlarge: "Bild vergrößern",
					close: "Schließen"
				}
			},
			complete: {
				message: "Vielen Dank",
				submessage:
					"Deine Verifizierung wird gerade bearbeitet. Du erhältst ein E-Mail, sobald sie abgeschlossen ist"
			},
			cross_device: {
				intro: {
					title: "Auf deinem Handy fortfahren",
					sub_title: "So gehst du vor:",
					description_li_1: "Sende einen sicheren Link an dein Handy",
					description_li_2: "Öffne den Link und erfülle die Aufgaben",
					description_li_3: "Komme wieder hierher zurück, um die Übermittlung abzuschließen",
					action: "Hole dir den sicheren Link"
				},
				client_success: {
					title: "Hochladen erfolgreich",
					sub_title: "Du kannst wieder deinen Computer verwenden, um fortzufahren",
					body: "Dein Computer benötigt vielleicht ein paar Sekunden zum Aktualisieren"
				},
				link: {
					title: "Sicheren Link anfragen",
					qr_code_sub_title: "QR-Code mit deinem Handy scannen",
					sms_sub_title: "Sende diesen einmaligen Link an dein Handy",
					copy_link_sub_title: "Link auf deinem Handy öffnen",
					options_divider_label: "oder",
					sms_option: "Link per SMS anfragen",
					copy_link_option: "Link kopieren",
					qr_code_option: "QR-Code scannen",
					copy_link: {
						action: "Kopieren",
						success: "Kopiert"
					},
					button_copy: {
						action: "Link senden",
						status: "Wird gesendet"
					},
					qr_code: {
						help_label: "Wie scanne ich den QR-Code",
						help_step_1: "Zeige mit deiner Handykamera auf den QR-Code",
						help_step_2:
							"Wenn das nicht funktioniert, lade einen QR-Code Scanner aus dem Google Play oder App Store"
					},
					sms_label: "Gib deine Handynummer ein:",
					copy_link_label: "Kopiere den Link in deinen mobilen Browser"
				},
				submit: {
					title: "Sehr gut, das ist alles, was wir brauchen",
					sub_title: "Wir können nun deine Identität verifizieren",
					selfie_uploaded: "Selfie hochgeladen",
					video_uploaded: "Video hochgeladen",
					action: "Verifizierung einreichen",
					multiple_docs_uploaded: "Dokumente hochgeladen",
					one_doc_uploaded: "Dokument hochgeladen"
				},
				phone_number_placeholder: "Handynummer eingeben",
				loading: "Wird geladen...",
				mobile_connected: {
					title: {
						message: "Mit Handy verbunden",
						submessage: "Sobald du fertig bist, kannst du zum nächsten Schritt übergehen"
					},
					tips: {
						item_1: "Lasse dieses Fenster offen, während du dein Handy verwendest",
						item_2: "Dein mobiler Link ist für eine Stunde gültig",
						item_3: "Diese Seite nicht aktualisieren"
					}
				},
				mobile_notification_sent: {
					title: "Auf dein Handy schauen",
					submessage: "Wir haben einen sicheren Link an %{number} gesendet",
					bold_message: "Es kann ein paar Minuten dauern, bis du ihn erhältst",
					tips: {
						item_1: "Lasse dieses Fenster offen, während du dein Handy verwendest",
						item_2: "Dein Link ist für eine Stunde gültig"
					},
					resend_link: "Link erneut senden"
				},
				switch_device: {
					header: "Mache ein Foto mit deinem Handy"
				},
				tips: "Tipps"
			},
			webcam_permissions: {
				allow_access: "Kamerazugriff erlauben",
				enable_webcam_for_selfie: "Bei Aufforderung Kamerazugriff erlauben, um fortzufahren",
				click_allow: "Wir können dich ohne deine Kamera nicht verifizieren",
				allow: "Erlauben",
				why: "Warum muss ich das machen?",
				if_denied:
					"Wenn du den Kamerazugriff verweigerst, kannst du keine Fotos machen und den Verifizierungsprozess nicht abschließen.",
				enable_webcam: "Kamera aktivieren",
				access_denied: "Kamerazugriff verweigert",
				recover_access: "Kamerazugriff wiederherstellen, um mit der Gesichtsverifizierung fortzufahren",
				recovery: "Wiederherstellen",
				follow_steps: "Folge diesen Schritten, um den Kamerazugriff wiederherzustellen:",
				grant_access: "Browser-Einstellungen ändern und Kamerazugriff erlauben",
				refresh_page: "Diese Seite aktualisieren, um Identitäts-Verifizierung neuzustarten",
				refresh: "Aktualisieren"
			},
			proof_of_address: {
				intro: {
					title: "Deine %{country} Adresse verifizieren",
					requirements: "Du benötigst ein Dokument, das:",
					shows_address: "Deine <strong>aktuelle</strong> Adresse anzeigt",
					matches_signup: "<strong>Entspricht</strong> der bei der Registrierung verwendeten Adresse",
					is_recent: "Ist dein <strong>aktuellstes</strong> Dokument",
					start: "Verifizierung starten"
				},
				guidance: {
					logo: "Logo",
					full_name: "Vollständiger Name",
					make_sure_it_shows: "Muss deutlich lesbar sein:",
					current_address: "Aktuelle Adresse",
					issue_date: "Ausstellungsdatum oder Erfassungszeitraum",
					continue: "Weiter"
				}
			},
			errors: {
				invalid_capture: {
					message: "Kein Dokument erfasst",
					instruction: "Stelle sicher, dass das gesamte Dokument auf dem Bild ist"
				},
				invalid_type: {
					message: "Datei nicht hochgeladen.",
					instruction: "Versuche es mit einem anderen Dateiformat."
				},
				unsupported_file: {
					message: "Dateiformat wird nicht unterstützt",
					instruction: "Versuche es mit JPG oder PNG"
				},
				invalid_size: {
					message: "Die Datei ist zu groß.",
					instruction: "Sie darf nicht größer als 10MB sein."
				},
				no_face: {
					message: "Kein Gesicht erfasst",
					instruction: "Dein Gesicht muss auf dem Selfie sichtbar sein"
				},
				multiple_faces: {
					message: "Mehrere Gesichter erfasst",
					instruction: "Auf dem Selfie darf nur dein Gesicht zu sehen sein"
				},
				server_error: {
					message: "Verbindung abgebrochen",
					instruction: "Bitte erneut versuchen"
				},
				glare_detected: {
					message: "Überbelichtung erkannt",
					instruction: "Alle Daten müssen klar und lesbar sein"
				},
				sms_failed: {
					message: "Etwas ist schiefgelaufen",
					instruction: "Kopiere den Link auf dein Handy"
				},
				sms_overuse: {
					message: "Zu viele fehlgeschlagene Versuche",
					instruction: "Kopiere den Link auf dein Handy"
				},
				lazy_loading: {
					message: "Beim Laden der Datei ist ein Fehler aufgetreten"
				},
				invalid_number: {
					message: "Überprüfe die Richtigkeit deiner Nummer"
				},
				generic_client_error: {
					message: "Etwas ist schiefgelaufen",
					instruction: "Du musst die Verifizierung auf deinem Computer neustarten"
				},
				forbidden_client_error: {
					message: "Etwas ist schiefgelaufen",
					instruction: "Der Link funktioniert nur auf mobilen Endgeräten"
				},
				camera_not_working: {
					message: "Kamera funktioniert nicht",
					instruction:
						"Sie ist vielleicht nicht angeschlossen. <fallback>Versuche es mit deinem Handy</fallback>."
				},
				camera_not_working_no_fallback: {
					instruction: "Stelle sicher, dass die Kamera deines Geräts funktioniert"
				},
				liveness_timeout: {
					message: "Sieht aus, als hättest du zu lange gebraucht",
					instruction:
						"Vergiss nicht, die Aufnahme zu stoppen sobald du fertig bist. <fallback>Video erneut aufnehmen</fallback>"
				},
				camera_inactive: {
					message: "Funktioniert die Kamera nicht?",
					instruction:
						"Überprüfe die Verbindung und Funktionsfähigkeit der Kamera. Du kannst mit der <fallback>Verifizierung auf deinem Handy fortfahren</fallback>"
				},
				camera_inactive_no_fallback: {
					instruction: "Stelle sicher, dass die Kamera deines Geräts funktioniert"
				},
				interrupted_flow_error: {
					message: "Kamera nicht erkannt",
					instruction: "Starte den Prozess auf einem anderen Gerät neu"
				},
				unsupported_android_browser: {
					message: "Browser wird nicht unterstützt",
					instruction: "Starte den Prozess in der aktuellsten Version von Google Chrome neu"
				},
				unsupported_ios_browser: {
					message: "Browser wird nicht unterstützt",
					instruction: "Starte den Prozess in der aktuellsten Version von Safari neu"
				}
			},
			accessibility: {
				close_sdk_screen: "Fenster der Identitätsverifizierung schließen",
				dismiss_alert: "Dismiss alert",
				camera_view: "Kameraansicht",
				shutter: "Foto machen",
				start_recording: "Aufnahme starten",
				stop_recording: "Aufnahme stoppen",
				replay_video: "Aufgenommenes Video erneut abspielen",
				document_types: "Dokumente zur Verifizierung der Identität",
				selfie_video_actions: "Handlungsschritte zur Aufnahme eines Selfie Videos",
				cross_device_verification: "Schritte, um mit der Verifizierung auf dem Handy fortzufahren",
				country_select: "Land auswählen"
			},
			passport: "Reisepass",
			driving_licence: "Führerschein",
			national_identity_card: "Personalausweis",
			short_passport: "Reisepass",
			short_driving_licence: "Führerschein",
			short_national_identity_card: "Ausweis",
			bank_building_society_statement: "Kontoauszug",
			utility_bill: "Betriebskostenabrechnung",
			benefit_letters: "Leistungsanspruch",
			government_letter: "Brief von einer staatlichen Institution",
			council_tax: "Brief des Finanzamts",
			loading: "Wird geladen",
			back: "Zurück",
			cancel: "Abbrechen",
			close: "Schließen",
			continue: "Weiter"
		},
		mobilePhrases: {
			capture: {
				driving_licence: {
					front: {
						instructions: "Mache ein Foto von der Vorderseite deines FÜhrerscheins"
					},
					back: {
						instructions: "Mache ein Foto von der Rückseite deines Führerscheins"
					}
				},
				national_identity_card: {
					front: {
						instructions: "Mache ein Foto von der Vorderseite deines Ausweises"
					},
					back: {
						instructions: "Mache ein Foto von der Rückseite deines Ausweises"
					}
				},
				passport: {
					front: {
						instructions: "Mache ein Foto von der Seite des Reisepasses mit deinem Bild"
					}
				},
				face: {
					instructions: "Mache ein Selfie, auf dem dein Gesicht zu sehen ist"
				}
			},
			errors: {
				camera_not_working: {
					instruction: "Mache stattdessen ein Foto im <fallback>normalen Kameramodus</fallback>"
				},
				camera_inactive: {
					instruction: "Mache stattdessen ein Foto im<fallback>normalen Kameramodus</fallback>"
				}
			}
		}
	},
	fra: {
		locale: "fr",
		phrases: {
			welcome: {
				title: "Ouvrir un nouveau compte",
				description_p_1: "Votre identité doit être vérifiée pour ouvrir un nouveau compte",
				description_p_2: "Cette démarche ne prendra que quelques minutes.",
				next_button: "Vérifier mon identité"
			},
			document_selector: {
				identity: {
					title: "Vérification de votre identité",
					hint: "Veuillez sélectionner le type de document à importer",
					passport_hint: "Côté photo",
					driving_licence_hint: "recto et verso",
					national_identity_card_hint: "recto et verso"
				},
				proof_of_address: {
					title: "Veuillez sélectionner un document %{country}",
					hint: "Ces documents sont susceptibles d'indiquer votre adresse de résidence actuelle",
					estatements_accepted: "Déclarations électroniques acceptées",
					utility_bill_hint: "Gaz, électricité, eau, ligne téléphonique ou ADSL",
					utility_bill_warning: "Désolé, aucune facture de forfait mobile n'est acceptée",
					benefits_letter_hint:
						"Allocations de foyer autorisées : allocation chômage, allocation logement et crédits d'impôt",
					government_letter_hint:
						"Toute lettre émise par le service public : droits aux prestations, bulletins de vote par correspondance, avis d'impôts, etc."
				}
			},
			capture: {
				driving_licence: {
					front: {
						title: "Soumission du permis de conduire (recto)",
						instructions: "Importez le recto du permis à partir de votre ordinateur",
						webcam: "Positionnez le recto du permis dans le cadre (il sera automatiquement détecté)"
					},
					back: {
						title: "Soumission du permis de conduire (verso)",
						instructions: "Importez le verso du permis à partir de votre ordinateur",
						webcam: "Positionnez le verso du permis dans le cadre (il sera automatiquement détecté)"
					}
				},
				national_identity_card: {
					front: {
						title: "Soumission de la carte nationale d'identité (recto)",
						instructions: "Importez le recto de votre carte à partir de votre ordinateur",
						webcam: "Positionnez le verso de votre carte dans le cadre (il sera automatiquement détecté)"
					},
					back: {
						title: "Soumission de la carte nationale d'identité (verso)",
						instructions: "Importez le verso de votre carte à partir de votre ordinateur",
						webcam: "Positionnez le recto de votre carte dans le cadre (il sera automatiquement détecté)"
					}
				},
				passport: {
					front: {
						title: "Soumission du passeport côté photo",
						instructions: "Importez le côté photo du passeport à partir de votre ordinateur",
						webcam: "Positionnez le côté photo du passeport à partir de votre ordinateur (il sera automatiquement détecté)"
					}
				},
				bank_building_society_statement: {
					front: {
						title: "Soumission du relevé",
						sub_title: "Datant de moins de <strong>3 mois</strong>",
						instructions: "Veuillez fournir la totalité du document pour un meilleur résultat",
						webcam: "Positionnez votre relevé bancaire dans le cadre (il sera automatiquement détecté)"
					}
				},
				utility_bill: {
					front: {
						title: "Soumission d'une facture",
						sub_title: "Datant de moins de <strong>3 mois</strong>",
						instructions: "Veuillez fournir la totalité du document pour un meilleur résultat",
						webcam: "Positionnez votre facture de services publics dans le cadre (il sera automatiquement détecté)"
					}
				},
				benefit_letters: {
					front: {
						title: "Soumission d'une attestation",
						sub_title: "Datant de moins de <strong>12 mois</strong>",
						instructions: "Veuillez fournir la totalité du document pour un meilleur résultat",
						webcam: "Positionnez votre attestation d'aide sociale dans le cadre (il sera automatiquement détecté)"
					}
				},
				council_tax: {
					front: {
						title: "Soumission d'une attestation",
						sub_title: "Datant de moins de <strong>12 mois</strong>",
						instructions: "Veuillez fournir la totalité du document pour un meilleur résultat",
						webcam: "Positionnez votre attestation de paiement de taxe d'habitation dans le cadre (il sera automatiquement détecté)"
					}
				},
				government_letter: {
					front: {
						title: "Attestation du service public",
						sub_title: "Datant de moins de <strong>12 mois</strong>",
						instructions: "Veuillez fournir la totalité du document pour un meilleur résultat",
						webcam: "Positionnez votre attestation du service public dans le cadre (il sera automatiquement détecté)"
					}
				},
				face: {
					title: "Prendre un selfie",
					upload_title: "Selfie",
					instructions: "Importez un selfie de votre ordinateur",
					intro: {
						title: "Prendre un selfie",
						subtitle: "Nous le comparerons avec votre document",
						selfie_instruction: "Regardez devant et assurez-vous que vos yeux sont bien visibles",
						glasses_instruction: "Enlevez vos lunettes, si nécessaire",
						accessibility: {
							selfie_capture_tips: "Conseils pour prendre un bon selfie"
						}
					}
				},
				liveness: {
					start: "Commencer",
					stop: "Stop",
					recording: "Enregistrer",
					press_record: "Appuyez sur enregistrer et suivez les instructions",
					intro: {
						title: "Veillons à ce que personne ne se fasse passer pour vous",
						two_actions:
							"Nous vous demanderons de vous filmer en effectuant <strong>2 actions simples</strong>",
						speak_out_loud: "La première : <strong>parler à voix haute</strong>",
						continue: "Continuer"
					},
					challenges: {
						position_face: "Positionnez votre visage dans l'ovale",
						recite: "Dites chaque chiffre à voix haute",
						movement: "Regardez par-dessus votre épaule %{side}",
						right: "droite",
						left: "gauche",
						done_next: "Une fois terminé, appuyez sur suivant",
						done_stop: "Une fois terminé, appuyez sur suivant",
						next: "Suivant"
					}
				},
				upload_document: "Importer",
				upload_file: "ou importer une photo – pas de scans ni de photocopies",
				take_photo: "Prendre la photo",
				switch_device: "Continuer sur mon téléphone"
			},
			confirm: {
				document: {
					title: "Vérification de la lisibilité",
					alt: "Photo de votre document"
				},
				driving_licence: {
					message:
						"Assurez-vous que les détails de votre permis de conduire sont lisibles, nets et sans reflet"
				},
				national_identity_card: {
					message: "Assurez-vous que les détails de votre carte d'identité sont lisibles, nets et sans reflet"
				},
				passport: {
					message: "Assurez-vous que les détails de votre passeport sont lisibles, nets et sans reflet"
				},
				bank_building_society_statement: {
					message: "Assurez-vous que les détails sont lisibles, nets et sans reflet"
				},
				utility_bill: {
					message: "Assurez-vous que les détails sont lisibles, nets et sans reflet"
				},
				benefit_letters: {
					message: "Assurez-vous que les détails sont lisibles, nets et sans reflet"
				},
				council_tax: {
					message: "Assurez-vous que les détails sont lisibles, nets et sans reflet"
				},
				face: {
					standard: {
						title: "Vérification du selfie",
						message: "Assurez-vous que votre selfie montre clairement votre visage",
						alt: "Photo de votre visage"
					},
					video: {
						title: "Vérification de votre selfie par vidéo"
					}
				},
				confirm: "Confirmer",
				continue: "Continuer",
				redo: "Reprendre",
				enlarge_image: {
					enlarge: "Agrandir l'image",
					close: "Fermer"
				}
			},
			complete: {
				message: "Merci",
				submessage:
					"Votre vérification est en cours de traitement, nous vous contacterons par e-mail une fois qu'elle aura été approuvée"
			},
			cross_device: {
				intro: {
					title: "Continuer sur mon téléphone",
					sub_title: "Instructions :",
					description_li_1: "Envoyez un lien sécurisé vers votre téléphone",
					description_li_2: "Ouvrez le lien et effectuez toutes les étapes",
					description_li_3: "Revenez ici pour finaliser la soumission",
					action: "Obtenir un lien sécurisé"
				},
				client_success: {
					title: "Importation réussie",
					sub_title: "Veuillez revenir sur votre ordinateur pour continuer",
					body: "Votre ordinateur peut prendre quelques secondes pour actualiser"
				},
				link: {
					title: "Obtenir mon lien sécurisé",
					qr_code_sub_title: "Scannez le QR code avec votre téléphone",
					sms_sub_title: "Envoyez ce lien unique à votre téléphone",
					copy_link_sub_title: "Ouvrir le lien sur mon téléphone",
					options_divider_label: "ou",
					sms_option: "Obtenez le lien par SMS",
					copy_link_option: "Copier le lien",
					qr_code_option: "Scanner le QR code",
					copy_link: {
						action: "Copier",
						success: "Copié"
					},
					button_copy: {
						action: "Envoyer le lien",
						status: "Envoyé"
					},
					qr_code: {
						help_label: "Comment scanner un QR code",
						help_step_1: "Pointez l'appareil photo de votre téléphone sur le QR code",
						help_step_2:
							"Si le QR code n'est pas détecté, téléchargez un scanner de QR code sur Google Play ou l'App Store"
					},
					sms_label: "Veuillez saisir votre numéro de téléphone :",
					copy_link_label: "Veuillez copier le lien sur votre navigateur mobile"
				},
				submit: {
					title: "Super, nous avons tout ce qu'il nous faut",
					sub_title: "Nous sommes prêts à vérifier votre identité",
					selfie_uploaded: "Selfie importé",
					video_uploaded: "Vidéo importée",
					action: "Soumettre la vérification",
					multiple_docs_uploaded: "Documents importés",
					one_doc_uploaded: "Document importé"
				},
				phone_number_placeholder: "Veuillez saisir votre numéro de téléphone",
				loading: "Chargement...",
				mobile_connected: {
					title: {
						message: "Connecté à votre téléphone",
						submessage: "Une fois que vous aurez terminé, nous vous ferons passer à l'étape suivante"
					},
					tips: {
						item_1: "Gardez cette fenêtre ouverte pendant l'utilisation de votre téléphone",
						item_2: "Le lien pour votre téléphone expirera dans une heure",
						item_3: "Ne rafraîchissez pas cette page"
					}
				},
				mobile_notification_sent: {
					title: "Vérification de votre téléphone",
					submessage: "Nous avons envoyé un lien sécurisé au %{number}",
					bold_message: "Quelques minutes peuvent être nécessaires pour arriver à destination",
					tips: {
						item_1: "Veuillez garder cette fenêtre ouverte pendant l'utilisation de votre téléphone",
						item_2: "Votre lien expirera dans une heure"
					},
					resend_link: "Renvoyer le lien"
				},
				switch_device: {
					header: "Prenez une photo avec votre téléphone"
				},
				tips: "Conseils"
			},
			webcam_permissions: {
				allow_access: "Autoriser l'accès à la caméra",
				enable_webcam_for_selfie: "Si demandé, vous devez activer la caméra pour continuer",
				click_allow: "Nous ne pouvons pas vérifier votre identité sans avoir accès à votre caméra",
				allow: "Autoriser",
				why: "Pourquoi dois-je faire ceci ?",
				if_denied:
					"Si vous refusez l'accès à la caméra, vous ne pourrez pas prendre des photos et finaliser la procédure de vérification.",
				enable_webcam: "Autoriser la caméra",
				access_denied: "Accès à la caméra refusé",
				recover_access: "Réautoriser l'accès à la caméra pour continuer la vérification de votre visage",
				recovery: "Réautoriser",
				follow_steps: "Suivez les étapes suivantes pour réautoriser l'accès à la caméra :",
				grant_access: "Autorisez l'accès à la caméra à partir des paramètres de votre navigateur",
				refresh_page: "Rafraîchissez cette page pour relancer la procédure de vérification",
				refresh: "Rafraîchir"
			},
			proof_of_address: {
				intro: {
					title: "Vérification de votre adresse en %{country}",
					requirements: "Vous avez besoin d'un document qui :",
					shows_address: "Indique votre adresse <strong>actuelle</strong>",
					matches_signup: "<strong>Correspond</strong> à l'adresse utilisée lors de votre inscription",
					is_recent: "Est le document le plus <strong>récent</strong>",
					start: "Démarrer la vérification"
				},
				guidance: {
					logo: "Logo",
					full_name: "Nom complet",
					make_sure_it_shows: "Assurez-vous qu'il montre clairement :",
					current_address: "Votre adresse actuelle",
					issue_date: "Date de délivrance ou de la période de validité",
					continue: "Continuer"
				}
			},
			errors: {
				invalid_capture: {
					message: "Aucun document détecté",
					instruction: "Vérifiez que tout le document figure sur la photo"
				},
				invalid_type: {
					message: "Fichier pas importé.",
					instruction: "Veuillez importer un autre type de fichier."
				},
				unsupported_file: {
					message: "Type de fichier pas pris en charge",
					instruction: "Importez un fichier JPG ou PNG"
				},
				invalid_size: {
					message: "Taille du fichier trop volumineuse.",
					instruction: "Doit être inférieure à 10MO."
				},
				no_face: {
					message: "Aucun visage détecté",
					instruction: "Votre visage doit figurer sur le selfie"
				},
				multiple_faces: {
					message: "Plusieurs visages détectés",
					instruction: "Seul votre visage doit figurer sur le selfie"
				},
				server_error: {
					message: "Erreur de connexion",
					instruction: "Veuillez réessayer"
				},
				glare_detected: {
					message: "Reflet détecté",
					instruction: "Tous les détails doivent être clairs et lisibles"
				},
				sms_failed: {
					message: "Quelque chose a mal tourné",
					instruction: "Copier le lien sur votre téléphone"
				},
				sms_overuse: {
					message: "Trop de tentatives échouées",
					instruction: "Copier le lien sur votre téléphone"
				},
				lazy_loading: {
					message: "Une erreur s'est produite lors du chargement du composant"
				},
				invalid_number: {
					message: "Vérifiez que votre numéro est correct"
				},
				generic_client_error: {
					message: "Quelque chose a mal tourné",
					instruction: "Vous devez relancer la procédure de vérification sur votre ordinateur"
				},
				forbidden_client_error: {
					message: "Quelque chose a mal tourné",
					instruction: "Le lien ne fonctionne que sur les appareils mobiles"
				},
				camera_not_working: {
					message: "Mauvais fonctionnement de la caméra",
					instruction: "La caméra semble déconnectée. <fallback>Veuillez utiliser votre téléphone</fallback>."
				},
				camera_not_working_no_fallback: {
					instruction: "Vérifiez le bon fonctionnement de votre caméra"
				},
				liveness_timeout: {
					message: "Délai dépassé",
					instruction:
						"N'oubliez pas d'appuyer sur stop une fois terminé. <fallback>Recommencer la vidéo</fallback>"
				},
				camera_inactive: {
					message: "Mauvais fonctionnement de la caméra ?",
					instruction:
						"Vérifiez qu'elle est bien connectée et fonctionnelle. Vous pouvez également <fallback>continuer la vérification sur votre téléphone</fallback>"
				},
				camera_inactive_no_fallback: {
					instruction: "Vérifiez que votre appareil est équipé d'une caméra"
				},
				interrupted_flow_error: {
					message: "Aucune caméra détectée",
					instruction: "Recommencez la procédure sur un autre appareil"
				},
				unsupported_android_browser: {
					message: "Navigateur incompatible",
					instruction: "Recommencez la procédure avec la dernière version de Google Chrome"
				},
				unsupported_ios_browser: {
					message: "Navigateur incompatible",
					instruction: "Recommencez la procédure avec la dernière version de Safari"
				}
			},
			accessibility: {
				close_sdk_screen: "Fermer l'écran de la procédure de vérification",
				dismiss_alert: "Rejeter l'alerte",
				camera_view: "Affichage de la caméra",
				shutter: "Prendre une photo",
				start_recording: "Commencer l'enregistrement",
				stop_recording: "Arrêter l'enregistrement",
				replay_video: "Relire la vidéo enregistrée",
				document_types: "Documents que vous pouvez utiliser pour vérifier votre identité",
				selfie_video_actions: "Actions pour enregistrer une vidéo de selfie",
				cross_device_verification:
					"Étapes nécessaires pour poursuivre la procédure de vérification sur votre téléphone",
				country_select: "Selectionner le pays"
			},
			passport: "Passeport",
			driving_licence: "Permis de conduire",
			national_identity_card: "Carte nationale d'identité",
			short_passport: "passeport",
			short_driving_licence: "permis",
			short_national_identity_card: "carte",
			bank_building_society_statement: "Relevé bancaire ou d'une société de crédit immobilier",
			utility_bill: "Facture de services publics",
			benefit_letters: "Attestion d'aide sociale",
			government_letter: "Attestation du service public ",
			council_tax: "Attestation de la taxe d'habitation",
			loading: "Chargement",
			back: "Retour",
			cancel: "Annuler",
			close: "Fermer",
			continue: "Continuer"
		},
		mobilePhrases: {
			capture: {
				driving_licence: {
					front: {
						instructions: "Prenez en photo le recto de votre permis"
					},
					back: {
						instructions: "Prenez en photo le verso de votre permis"
					}
				},
				national_identity_card: {
					front: {
						instructions: "Prenez en photo le recto de votre carte"
					},
					back: {
						instructions: "Prenez en photo le verso de votre carte"
					}
				},
				passport: {
					front: {
						instructions: "Prenez en photo votre passeport côté photo"
					}
				},
				face: {
					instructions: "Prenez un selfie montrant votre visage"
				}
			},
			errors: {
				camera_not_working: {
					instruction:
						"Prenez une photo en utilisant le <fallback>mode appareil photo normal</fallback> à la place"
				},
				camera_inactive: {
					instruction:
						"Prenez une photo en utilisant le <fallback>mode appareil photo normal</fallback> à la place"
				}
			}
		}
	},
	eng: {
		locale: "en",
		phrases: {
			complete: {
				message: "Thank you",
				submessage: "Your verification is being processed and we will email you once it has been approved"
			}
		}
	},
	spa: {
		locale: "es_ES",
		phrases: {
			complete: {
				message: "Gracias",
				submessage:
					"Estamos procesando tu verificación y te enviaremos un correo electrónico cuando sea aprobada"
			}
		}
	},
	esp: {
		locale: "es_ES",
		phrases: {
			complete: {
				message: "Gracias",
				submessage:
					"Estamos procesando tu verificación y te enviaremos un correo electrónico cuando sea aprobada"
			}
		}
	},
	tur: {
		locale: "tr",
		phrases: {
			welcome: {
				title: "Yeni banka hesabı açın",
				description_p_1: "Yeni bir banka hesabı açmak için kimliğinizi doğrulamamız gerekecek.",
				description_p_2: " Bu işlem yalnızca birkaç dakika sürer.",
				next_button: "Kimlik doğrulama"
			},
			document_selector: {
				identity: {
					title: "Kimliğinizi doğrulayın",
					hint: "Yüklemek istediğiniz belge türünü seçin",
					passport_hint: "Fotoğraflı olan sayfayı gösterin",
					driving_licence_hint: "Ön ve arka",
					national_identity_card_hint: "Ön ve arka"
				},
				proof_of_address: {
					title: " Bir %{country} belgesi seçin",
					hint: "Bunlar mevcut ev adresinizi gösterme olasılığı en yüksek belgelerdir",
					estatements_accepted: "Online ekstreler kabul edilir",
					utility_bill_hint: "Doğalgaz, elektrik, su, sabit hat ya da geniş bant",
					utility_bill_warning: "Maalesef, cep telefonu faturaları dahil değil",
					benefits_letter_hint:
						" İş arayan ödeneği, konut yardımı, vergi kredileri gibi devlet tarafından yetkilendirilmiş sosyal yardımlar ",
					government_letter_hint:
						"Bir devlet kurumu tarafından verilen herhangi bir mektup; sosyal yardım, seçim kartları, vergi mektupları vb."
				}
			},
			capture: {
				driving_licence: {
					front: {
						title: "Ehliyetinizi gönderin (ön yüzünü)",
						instructions: "Bilgisayarınızdan ehliyetinizin ön yüzünü yükleyin",
						webcam: "Ehliyetinizin ön yüzünü çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					},
					back: {
						title: "Ehliyetinizi gönderin (arka yüzünü)",
						instructions: "Ehliyetinizin arka yüzünü bilgisayarınızdan yükleyin",
						webcam: "Ehliyetinizin arka yüzünü çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				national_identity_card: {
					front: {
						title: " Kimlik kartınızı gönderin (ön yüzü)",
						instructions: "Kimliğinizin ön yüzünü bilgisayarınızdan yükleyin.",
						webcam: "Kimliğinizin ön yüzünü çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					},
					back: {
						title: "Kimlik kartınızı gönderin (arka yüzü)",
						instructions: "Kimlik kartınızın arka yüzünü bilgisayarınızdan yükleyin",
						webcam: "Kimliğinizin arka yüzünü çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				passport: {
					front: {
						title: "Pasaportunuzun fotoğraflı sayfasını gönderin",
						instructions: "Pasaportunuzun fotoğraflı sayfasını bilgisayarınızdan yükleyin",
						webcam: "Pasaportunuzun fotoğraflı sayfasını çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				bank_building_society_statement: {
					front: {
						title: "Ekstrenizi gönderin",
						sub_title: " <strong>3 aydan </strong> eski olmamalı",
						instructions: "En iyi sonucu almak için belgenin tamamını yükleyin",
						webcam: "Banka ekstrenizi çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				utility_bill: {
					front: {
						title: "Faturanızı gönderin",
						sub_title: " <strong>3 aydan </strong> eski olmamalı",
						instructions: "En iyi sonucu almak için belgenin tamamını yükleyin",
						webcam: "Hizmet faturanızı (elektrik/su/doğalgaz) çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				benefit_letters: {
					front: {
						title: "Mektup gönder",
						sub_title: " <strong> 12 aydan </strong> eski olmamalı",
						instructions: "En iyi sonucu almak için belgenin tamamını yükleyin",
						webcam: " Sosyal yardım mektubunuzu çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				council_tax: {
					front: {
						title: "Mektup gönder",
						sub_title: "<strong>12 aydan</strong> eski olmamalı",
						instructions: "En iyi sonucu almak için belgenin tamamını yükleyin",
						webcam: "Belediye vergisi mektubunuzu çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				government_letter: {
					front: {
						title: "Bir devlet kurumundan mektup",
						sub_title: " <strong>12 aydan</strong> eski olmamalı",
						instructions: "En iyi sonucu almak için belgenin tamamını yükleyin",
						webcam: "Devlet kurumundan gelen mektubunuzu çerçeveye yerleştirin (otomatik olarak algılanacaktır)"
					}
				},
				face: {
					title: "Bir selfie çekin",
					upload_title: "Selfie",
					instructions: "Selfie'yi bilgisayarınızdan yükleyin",
					intro: {
						title: "Selfie çekin ",
						subtitle: "Selfie'yi belgenizle karşılaştıracağız",
						selfie_instruction: "Öne doğru bakın ve gözlerinizin açıkça görünür olduğundan emin olun",
						glasses_instruction: "Gözlüklerinizi çıkarın",
						accessibility: {
							selfie_capture_tips: "İyi bir selfie çekme ipuçları"
						}
					}
				},
				liveness: {
					start: "Başla",
					stop: "Dur",
					recording: "Kaydediyor",
					press_record: "KAYIT BUTONUNA BASIN ve talimatları izleyin",
					intro: {
						title: "Kimsenin sizi taklit etmediğinden emin olmamız gerekiyor",
						two_actions: "Sizden <strong> 2 basit işlem </strong> gerçekleştirmenizi isteyeceğiz",
						speak_out_loud:
							"Bunlardan birincisi, sizden istenen kelime veya sayıları<strong> yüksek sesle okumanız</strong>",
						continue: "Devam"
					},
					challenges: {
						position_face: "Yüzünüzü çerçevenin içine yerleştirin",
						recite: "Her rakamı yavaşça ve yüksek sesle söyleyin",
						movement: "Başınızı tam olarak ve yavaşça %{side} a çevirin",
						right: "Sağ",
						left: "Sol",
						done_next: "İşiniz bittiğinde 'ileri' butonuna tıklayın",
						done_stop: "İşiniz bittiğinde 'kırmızı' butona tıklayın",
						next: "İleri"
					}
				},
				upload_document: "Yükle",
				upload_file: "ya da fotoğraf yükle – tarama ya da fotokopi geçerli değil",
				take_photo: "Fotoğraf çek",
				switch_device: "Telefonda devam et"
			},
			confirm: {
				document: {
					title: "Okunabilirliği kontrol et",
					alt: "Belgenizin fotoğrafı"
				},
				driving_licence: {
					message:
						"Ehliyetinizdeki verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				national_identity_card: {
					message:
						"Kimlik kartınızdaki verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				passport: {
					message:
						"Pasaportunuzdaki verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				bank_building_society_statement: {
					message:
						"Verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				utility_bill: {
					message:
						"Verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				benefit_letters: {
					message:
						"Verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				council_tax: {
					message:
						"Verilerin açıkça okunabilir olduğundan ve görüntünün bulanık veya aşırı pozlanmış olmadığından emin olun"
				},
				face: {
					standard: {
						title: "Selfie'nizi kontrol edin",
						message: "Selfie'nizin yüzünüzü açıkça gösterdiğinden emin olun",
						alt: "Yüzünüzün fotoğrafı"
					},
					video: {
						title: "Selfie videonuzu kontrol edin"
					}
				},
				confirm: "Kabul et",
				continue: "Devam et",
				redo: "Yeniden yap",
				enlarge_image: {
					enlarge: "Resmi büyüt",
					close: "Kapat"
				}
			},
			complete: {
				message: "Teşekkürler",
				submessage: "Doğrulama işleminiz gerçekleştiriliyor, onaylandıktan sonra size e-posta göndereceğiz"
			},
			cross_device: {
				intro: {
					title: "Telefonunuzda devam edin",
					sub_title: "Bu işlemi şu şekilde yapabilirsiniz:",
					description_li_1: "Telefonunuza bir güvenlik linki gönderin",
					description_li_2: "Linki açın ve görevleri tamamlayın",
					description_li_3: "Gönderiyi tamamlamak için burayı tekrar kontrol edin",
					action: "Güvenlik linkini al"
				},
				client_success: {
					title: "Yüklemeler başarılı",
					sub_title: "Artık bilgisayarınıza geri dönüp orada devam edebilirsiniz",
					body: "Bilgisayarınızın güncellenmesi bir kaç saniye sürebilir"
				},
				link: {
					title: "Güvenlik linkini al",
					qr_code_sub_title: "QR kodunu telefonunuzla tarayın",
					sms_sub_title: "Bir kere kullanabileceğiniz bu linki telefonunuza gönderin",
					copy_link_sub_title: "Linki telefonunuzda açın",
					options_divider_label: "ya da",
					sms_option: "Linki SMS olarak alın",
					copy_link_option: "linki kopyala",
					qr_code_option: "QR kodunu tara",
					copy_link: {
						action: "Kopyala",
						success: "Kopyalandı"
					},
					button_copy: {
						action: "linki gönder",
						status: "Gönderiyor"
					},
					qr_code: {
						help_label: "QR kod nasıl taranır?",
						help_step_1: "Telefonunuzun kamerasını QR koduna doğrultun",
						help_step_2:
							"Eğer çalışmazsa, Google Play'den veya App Store'dan bir QR kodu tarayıcısı indirin"
					},
					sms_label: "Cep telefon numaranızı yazın:",
					copy_link_label: "Linki mobil tarayıcınıza kopyalayın"
				},
				submit: {
					title: "Harika, ihtiyacımız olan her şey bu kadar",
					sub_title: "Kimliğinizi doğrulamak için şimdi hazırız!",
					selfie_uploaded: "Selfie yüklendi",
					video_uploaded: "Video yüklendi",
					action: "Doğrulamayı gönder",
					multiple_docs_uploaded: "Belgeler yüklendi",
					one_doc_uploaded: "Belge yüklendi"
				},
				phone_number_placeholder: "Telefon numaranızı yazın",
				loading: "Yükleniyor...",
				mobile_connected: {
					title: {
						message: "Cep telefonunuza bağlandı",
						submessage: "İşiniz bittiğinde bir sonraki adıma geçebilirsiniz"
					},
					tips: {
						item_1: "Telefonunuzu kullanırken bu pencereyi açık tutun",
						item_2: "Telefonunuza gelen linkin bir saat içinde süresi dolacak",
						item_3: "Bu sayfayı yenilemeyin"
					}
				},
				mobile_notification_sent: {
					title: "  Telefonunuzu kontrol edin",
					submessage: "%{number} numarasına bir güvenlik linki gönderdik",
					bold_message: " Gelmesi bir kaç dakika sürebilir",
					tips: {
						item_1: " Telefonunuzu kullanırken bu pencereyi açık tutun",
						item_2: "Linkinizin bir saat içinde süresi dolacak"
					},
					resend_link: "linki yeniden gönder"
				},
				switch_device: {
					header: "Telefonunuzla bir fotoğraf çekin"
				},
				tips: "İpuçları"
			},
			webcam_permissions: {
				allow_access: "Kamera erişimine izin ver",
				enable_webcam_for_selfie: "Devam etmek için kamera erişimine izin vermeniz gerekir",
				click_allow: "Kameranızı kullanmadan sizi doğrulayamayız",
				allow: "İzin ver",
				why: "Neden bunu yapmam gerekir?",
				if_denied:
					"Kamera erişimini engellerseniz resim çekemeyeceksiniz ve doğrulama işlemini tamamlayamayacaksınız.",
				enable_webcam: "Kameraya izin ver",
				access_denied: "Kamera erişimi engellendi",
				recover_access: "Yüz doğrulama işlemine devam etmek için kamera erişimini yeniden kurun",
				recovery: "Yeniden kur",
				follow_steps: "kamera erişimini için yeniden kurmak şu adımları izleyin:",
				grant_access: "Tarayıcı ayarlarınızdan kameranıza erişim izni verin",
				refresh_page: "Kimlik doğrulama işlemini yeniden başlatmak için bu sayfayı yenileyin",
				refresh: "Yenile"
			},
			proof_of_address: {
				intro: {
					title: " %{country} adresinizi doğrulayın",
					requirements: "Belgenizin şu şekilde olması gerekir:",
					shows_address: " <strong>güncel </strong> adresinizi gösterin",
					matches_signup: " <strong> kayıt olduğunuzda kullanılan adresinizle </strong> eşleşiyor",
					is_recent: " Bu sizin en <strong> güncel</strong> belgeniz mi?",
					start: "Doğrulama işlemini başlat"
				},
				guidance: {
					logo: "Logo",
					full_name: "Tam adınız",
					make_sure_it_shows: "Net bir şekilde okunaklı olmalıdır:",
					current_address: "Güncel adresiniz",
					issue_date: "Düzenlenme tarihi ya da kayıt tarihi",
					continue: "Devam et"
				}
			},
			errors: {
				invalid_capture: {
					message: "Belge algılanamadı",
					instruction: "Tüm belgelerin fotoğrafta olduğundan emin olun"
				},
				invalid_type: {
					message: "Dosya yüklenemedi.",
					instruction: "Başka bir dosya türünü kullanmayı deneyin."
				},
				unsupported_file: {
					message: "Dosya türü desteklenmiyor",
					instruction: "JPG ya da PNG dosyalarını kullanmayı deneyin"
				},
				invalid_size: {
					message: "Dosya boyutu aşıldı.",
					instruction: "10MB altında olmalıdır."
				},
				no_face: {
					message: "Yüz algılanamadı",
					instruction: "Yüzünüzün selfie'de görünmesi gerekir"
				},
				multiple_faces: {
					message: "Birden fazla yüz algılandı",
					instruction: "Selfie'de yalnızca sizin yüzünüz görünmelidir"
				},
				server_error: {
					message: "Bağlantı koptu",
					instruction: "Lütfen tekrar deneyin"
				},
				glare_detected: {
					message: "Parlaklık algılandı",
					instruction: "Tüm detayların açık ve okunaklı olması gerekir"
				},
				sms_failed: {
					message: "Bir şeyler ters gitti",
					instruction: "Bu linki telefonunuza kopyalayın"
				},
				sms_overuse: {
					message: "Çok fazla başarısız girişim",
					instruction: "Linki telefonunuza kopyalayın"
				},
				lazy_loading: {
					message: "Dosya yüklenirken bir hata oluştu"
				},
				invalid_number: {
					message: "Numaranızın doğruluğunu kontrol edin"
				},
				generic_client_error: {
					message: "Bir şeyler ters gitti",
					instruction: "Bilgisayarınızda doğrulama işlemini yeniden başlatmanız gerekecek"
				},
				forbidden_client_error: {
					message: "Bir şeyler ters gitti",
					instruction: "Bu link yalnızca mobil cihazlarda çalışır"
				},
				camera_not_working: {
					message: "Kamera çalışmıyor",
					instruction:
						"Bağlantısı kesilmiş olabilir. <fallback> yerine telefonunuzu kullanmayı deneyin</fallback>."
				},
				camera_not_working_no_fallback: {
					instruction: "Cihazınızın kamerasının çalıştığından emin olun"
				},
				liveness_timeout: {
					message: " Galiba zaman aşımına uğradınız",
					instruction:
						"İşiniz bittiğinde 'durdur' butonuna basmayı unutmayın. <fallback> Video işlemlerini tekrar yapın </fallback>"
				},
				camera_inactive: {
					message: "Kamera çalışmıyor mu?",
					instruction:
						"Kameranızın bağlı ve işlevsel olduğundan emin olun. <fallback> doğrulama işleminize telefonunuzda da devam edebilirsiniz </fallback>"
				},
				camera_inactive_no_fallback: {
					instruction: "Cihazınızdaki kameranın çalıştığından emin olun"
				},
				interrupted_flow_error: {
					message: "Kamera algılanmadı",
					instruction: "Başka bir cihazda işlemi yeniden başlatın"
				},
				unsupported_android_browser: {
					message: "Desteklenmeyen tarayıcı",
					instruction: "Google Crome'un en son sürümünde işlemi yeniden başlatın"
				},
				unsupported_ios_browser: {
					message: "Desteklenmeyen tarayıcı",
					instruction: "Safari'nin en son sürümünde işlemi yeniden başlatın"
				}
			},
			accessibility: {
				close_sdk_screen: "Kimlik doğrulama ekranını kapat",
				dismiss_alert: "Uyarıyı reddet",
				camera_view: "Kameradan görüntüle",
				shutter: "Bir fotoğraf çekin",
				start_recording: "Kayda başla",
				stop_recording: "Kaydı durdur",
				replay_video: "Kayıtlı videonuzu tekrar oynatın",
				document_types: "Kimliğinizi doğrulamak için kullanabileceğiniz belgeler",
				selfie_video_actions: "Selfie videosu kaydetme işlemleri",
				cross_device_verification: "Cihazınızda doğrulama işlemine devam etmek için gerekli adımlar",
				country_select: "Ülke seçin"
			},
			passport: "Pasaport",
			driving_licence: "Ehliyet",
			national_identity_card: "Kimlik Kartı",
			short_passport: "pasaport",
			short_driving_licence: "Ehliyet",
			short_national_identity_card: "Kimlik kartı",
			bank_building_society_statement: "Ekstre",
			utility_bill: "Elektrik/su/doğalgaz faturası",
			benefit_letters: "Sosyal yardım mektubu",
			government_letter: "Devlet kurumundan mektup",
			council_tax: "Belediye vergisi mektubu",
			loading: "Yükleniyor",
			back: "Geri",
			cancel: "İptal et",
			close: "Kapat",
			continue: "Devam et"
		},
		mobilePhrases: {
			capture: {
				driving_licence: {
					front: {
						instructions: "Ehliyetinizin ön yüzünün fotoğrafını çekin"
					},
					back: {
						instructions: "Ehliyetinizin arka yüzünün fotoğrafını çekin"
					}
				},
				national_identity_card: {
					front: {
						instructions: "Kimliğinizin ön yüzünün fotoğrafını çekin"
					},
					back: {
						instructions: "Kimliğinizin arka yüzünün fotoğrafını çekin"
					}
				},
				passport: {
					front: {
						instructions: "Pasaportunuzun fotoğraflı sayfasını çekin"
					}
				},
				face: {
					instructions: "Yüzünüzü gösteren bir selfie çekin"
				}
			},
			errors: {
				camera_not_working: {
					instruction: "</fallback> yerine <fallback>temel kamera modunu kullanarak fotoğraf çekin "
				},
				camera_inactive: {
					instruction: "</fallback> yerine <fallback>temel kamera modunu kullanarak fotoğraf çekin"
				}
			}
		}
	},
	ita: {
		locale: "it",
		phrases: {
			welcome: {
				title: "Apri il tuo nuovo account",
				description_p_1: "Per aprire un conto, dovremo verificare la tua identità.",
				description_p_2: "Ci vorranno solo un paio di minuti.",
				next_button: "Verifica identità"
			},
			document_selector: {
				identity: {
					title: "Verifica la tua identità",
					hint: "Seleziona il tipo di documento che desideri caricare",
					passport_hint: "Pagina della foto del viso",
					driving_licence_hint: "Fronte e retro",
					national_identity_card_hint: "Fronte e retro"
				},
				proof_of_address: {
					title: "Seleziona un documento %{country}",
					hint: "Questi sono i documenti che più probabilmente riportano il tuo indirizzo di casa attuale",
					estatements_accepted: "dichiarazioni elettroniche accettate",
					utility_bill_hint: "Gas, elettricità, acqua, rete fissa o banda larga",
					utility_bill_warning: "Spiacenti, non sono ammesse le bollette del cellulare",
					benefits_letter_hint:
						"Prestazioni familiari autorizzate dal governo, ad es. indennità di disoccupazione, prestazioni abitative, crediti d'imposta",
					government_letter_hint:
						"Qualsiasi lettera emessa dal governo, ad es. diritto alle prestazioni, lettere di voto, lettere fiscali, ecc."
				}
			},
			capture: {
				driving_licence: {
					front: {
						title: "Invia patente (fronte)",
						instructions: "Carica la parte anteriore della patente dal tuo computer",
						webcam: "Posiziona la parte anteriore della patente nel riquadro (verrà rilevata automaticamente)"
					},
					back: {
						title: "Invia patente (retro)",
						instructions: "Carica il retro della patente dal tuo computer",
						webcam: "Posiziona il retro della patente nel riquadro (verrà rilevato automaticamente)"
					}
				},
				national_identity_card: {
					front: {
						title: "Invia la carta d'identità (fronte)",
						instructions: "Carica la parte anteriore della carta d'identità dal tuo computer",
						webcam: "Posiziona la parte anteriore della carta d'identità nel riquadro (verrà rilevato automaticamente)"
					},
					back: {
						title: "Invia la carta d'identità (retro)",
						instructions: "Carica il retro della carta d'identità dal tuo computer",
						webcam: "Posiziona il retro della carta d'identità nel riquadro (verrà rilevato automaticamente)"
					}
				},
				passport: {
					front: {
						title: "Invia la pagina con la foto del passaporto",
						instructions: "Carica la pagina con la foto del passaporto dal tuo computer",
						webcam: "Posiziona la pagina della foto del passaporto nel riquadro (verrà rilevata automaticamente)"
					}
				},
				bank_building_society_statement: {
					front: {
						title: "Presenta il estrato",
						sub_title: "Deve essere stato rilasciato negli <strong>ultimi 3 mesi</strong>",
						instructions: "Fornisci l'intera pagina del documento per ottenere migliori risultati",
						webcam: "Posiziona il tuo estrato nel riquadro (verrà rilevato automaticamente)"
					}
				},
				utility_bill: {
					front: {
						title: "Invia la bolletta",
						sub_title: "Deve essere stato rilasciato negli <strong>ultimi 3 mesi</strong>",
						instructions: "Fornisci l'intera pagina del documento per ottenere migliori risultati",
						webcam: "Posiziona la tua bolletta nel riquadro (verrà rilevata automaticamente)"
					}
				},
				benefit_letters: {
					front: {
						title: "Invia lettera",
						sub_title: "Deve essere stato rilasciato negli <strong>ultimi 12 mesi</strong>",
						instructions: "Fornisci l'intera pagina del documento per ottenere migliori risultati",
						webcam: "Posiziona la tua lettera di prestazioni nel riquadro (verrà rilevata automaticamente)"
					}
				},
				council_tax: {
					front: {
						title: "Invia lettera",
						sub_title: "Deve essere stato rilasciato negli <strong>ultimi 12 mesi</strong>",
						instructions: "Fornisci l'intera pagina del documento per ottenere migliori risultati",
						webcam: "Posiziona la tua lettera d'imposta comunale nel riquadro (verrà rilevata automaticamente)"
					}
				},
				government_letter: {
					front: {
						title: "Lettera governativa",
						sub_title: "Deve essere stato rilasciato negli <strong>ultimi 12 mesi</strong>",
						instructions: "Fornisci l'intera pagina del documento per ottenere migliori risultati",
						webcam: "Posiziona la tua lettera governativa nel riquadro (verrà rilevata automaticamente)"
					}
				},
				face: {
					title: "Fai un selfie",
					upload_title: "Selfie",
					instructions: "Carica un selfie dal tuo computer",
					intro: {
						title: "Fai un selfie",
						subtitle: "Lo confronteremo con il tuo documento",
						selfie_instruction: "Voltati in avanti e assicurati che i tuoi occhi siano ben visibili",
						glasses_instruction: "Togliti gli occhiali, se necessario",
						accessibility: {
							selfie_capture_tips: "Consigli per scattare un buon selfie"
						}
					}
				},
				liveness: {
					start: "Inizia",
					stop: "Stop",
					recording: "Registrazione in corso",
					press_record: "Premi Registra e segui le istruzioni",
					intro: {
						title: "Assicuriamoci che nessuno ti stia impersonando",
						two_actions: "Ti chiederemo di filmarti mentre svolgi <strong>2 semplici azioni</strong>",
						speak_out_loud: "Si tratta di <strong>parlare ad alta voce</strong>",
						continue: "Continua"
					},
					challenges: {
						position_face: "Posiziona il viso nell'ovale",
						recite: "Pronuncia ogni cifra ad alta voce",
						movement: "Guarda sopra la tua spalla %{side}",
						right: "destra",
						left: "sinistra",
						done_next: "Quando hai finito, premi Avanti",
						done_stop: "Quando hai finito, premi Stop",
						next: "Avanti"
					}
				},
				upload_document: "Carica",
				upload_file: "o carica una foto; non utilizzare scansioni o fotocopie",
				take_photo: "Scatta la foto",
				switch_device: "Continua sul telefono"
			},
			confirm: {
				document: {
					title: "Controlla la leggibilità",
					alt: "Foto del tuo documento"
				},
				driving_licence: {
					message:
						"Assicurati che i dati della tua patente siano chiari da leggere, senza sfocatura o riverbero"
				},
				national_identity_card: {
					message:
						"Assicurati che i dati della tua carta d'identità siano chiari da leggere, senza sfocatura o riverbero"
				},
				passport: {
					message:
						"Assicurati che i dati del tuo passaporto siano chiari da leggere, senza sfocatura o riverbero"
				},
				bank_building_society_statement: {
					message: "Assicurati che i dettagli siano chiari da leggere, senza sfocatura o riverbero"
				},
				utility_bill: {
					message: "Assicurati che i dettagli siano chiari da leggere, senza sfocatura o riverbero"
				},
				benefit_letters: {
					message: "Assicurati che i dettagli siano chiari da leggere, senza sfocatura o riverbero"
				},
				council_tax: {
					message: "Assicurati che i dettagli siano chiari da leggere, senza sfocatura o riverbero"
				},
				face: {
					standard: {
						title: "Controlla il selfie",
						message: "Assicurati che il tuo selfie mostri chiaramente il tuo viso",
						alt: "Foto del tuo viso"
					},
					video: {
						title: "Controlla il video selfie"
					}
				},
				confirm: "Conferma",
				continue: "Continua",
				redo: "Ripeti",
				enlarge_image: {
					enlarge: "Ingrandisci l'immagine",
					close: "Chiudi"
				}
			},
			complete: {
				message: "Grazie",
				submessage:
					"Noi attualmente processiamo la tua verificazione e ti invieremo un'email quando è stata approvata"
			},
			cross_device: {
				intro: {
					title: "Continua sul tuo telefono",
					sub_title: "Ecco come fare:",
					description_li_1: "Invia un link sicuro al tuo telefono",
					description_li_2: "Apri il link e completa le azioni",
					description_li_3: "Controlla qui per terminare l'invio",
					action: "Ottieni un link sicuro"
				},
				client_success: {
					title: "Caricamenti completati",
					sub_title: "Ora puoi tornare al computer per continuare",
					body: "Il tuo computer potrebbe impiegare alcuni secondi per eseguire l'aggiornamento"
				},
				link: {
					title: "Ottieni il tuo link sicuro",
					qr_code_sub_title: "Scansiona il codice QR con il telefono",
					sms_sub_title: "Invia questo link monouso al tuo telefono",
					copy_link_sub_title: "Apri il link sul tuo cellulare",
					options_divider_label: "oppure",
					sms_option: "Ricevi il link via SMS",
					copy_link_option: "Copia link",
					qr_code_option: "Scansiona codice QR",
					copy_link: {
						action: "Copia",
						success: "Copiato"
					},
					button_copy: {
						action: "Invia il link",
						status: "Invio in corso"
					},
					qr_code: {
						help_label: "Come scansionare un codice QR",
						help_step_1: "Punta la fotocamera del telefono verso il codice QR",
						help_step_2: "Se non funziona, scarica uno scanner di codici QR da Google Play o da App Store"
					},
					sms_label: "Inserisci il tuo numero di cellulare:",
					copy_link_label: "Copia il link sul browser del tuo cellulare"
				},
				submit: {
					title: "Fantastico, è tutto ciò di cui abbiamo bisogno",
					sub_title: "Siamo ora pronti a verificare la tua identità",
					selfie_uploaded: "Selfie caricato",
					video_uploaded: "Video caricato",
					action: "Invia verifica",
					multiple_docs_uploaded: "Documenti caricati",
					one_doc_uploaded: "Documento caricato"
				},
				phone_number_placeholder: "Inserisci il numero di cellular",
				loading: "Caricamento...",
				mobile_connected: {
					title: {
						message: "Collegato al tuo cellulare",
						submessage: "Una volta finito, ti indirizzeremo alla fase successiva"
					},
					tips: {
						item_1: "Tieni aperta questa finestra mentre usi il cellulare",
						item_2: "Il link del tuo cellulare scadrà tra un'ora",
						item_3: "Non aggiornare questa pagina"
					}
				},
				mobile_notification_sent: {
					title: "Controlla il tuo cellulare",
					submessage: "Abbiamo inviato un link sicuro a %{number}",
					bold_message: "Potrebbero volerci alcuni minuti per arrivare",
					tips: {
						item_1: "Tieni aperta questa finestra mentre usi il cellulare",
						item_2: "Il tuo link scadrà tra un'ora"
					},
					resend_link: "Invia nuovamente il link"
				},
				switch_device: {
					header: "Scatta una foto con il tuo telefono"
				},
				tips: "Suggerimenti"
			},
			webcam_permissions: {
				allow_access: "Consentire l'accesso alla fotocamera",
				enable_webcam_for_selfie:
					"Quando richiesto, è necessario abilitare l'accesso alla fotocamera per continuare",
				click_allow: "Non possiamo effettuare la verifica senza utilizzare la tua fotocamera",
				allow: "Consenti",
				why: "Perché devo farlo?",
				if_denied:
					"Se neghi l'accesso alla fotocamera, non sarà possibile scattare foto e completare il processo di verifica.",
				enable_webcam: "Attiva la fotocamera",
				access_denied: "Accesso alla fotocamera negato",
				recover_access: "Ripristina l'accesso alla fotocamera per continuare la verifica del viso",
				recovery: "Ripristino",
				follow_steps: "Segui questa procedura per recuperare l'accesso alla fotocamera:",
				grant_access: "Consenti l'accesso alla tua fotocamera dalle impostazioni del browser",
				refresh_page: "Aggiorna questa pagina per riavviare il processo di verifica dell'identità",
				refresh: "Aggiorna"
			},
			proof_of_address: {
				intro: {
					title: "Verifichiamo il tuo indirizzo %{country}",
					requirements: "Avrai bisogno di un documento che:",
					shows_address: "Mostra il tuo indirizzo <strong>attuale</strong>",
					matches_signup:
						"<strong>Corrisponde</strong> all'indirizzo che hai usato al momento dell'iscrizione",
					is_recent: "È il tuo documento più <strong>recente</strong>",
					start: "Avvia la verifica"
				},
				guidance: {
					logo: "Logo",
					full_name: "Nome e cognome",
					make_sure_it_shows: "Assicurati che mostri chiaramente che:",
					current_address: "Indirizzo attuale",
					issue_date: "Data di rilascio o periodo di resoconto",
					continue: "Continua"
				}
			},
			errors: {
				invalid_capture: {
					message: "Nessun documento rilevato",
					instruction: "Assicurati che tutto il documento sia contenuto nella foto"
				},
				invalid_type: {
					message: "File non caricato.",
					instruction: "Prova a utilizzare un altro tipo di file."
				},
				unsupported_file: {
					message: "Tipo di file non supportato",
					instruction: "Prova a usare un file JPG o PNG"
				},
				invalid_size: {
					message: "Dimensione del file superata.",
					instruction: "Deve essere inferiore a 10 MB."
				},
				no_face: {
					message: "Nessun viso trovato",
					instruction: "Il tuo viso è necessario nel selfie"
				},
				multiple_faces: {
					message: "Trovati più visi",
					instruction: "Solo il tuo viso può trovarsi nel selfie"
				},
				server_error: {
					message: "Connessione persa",
					instruction: "Ti preghiamo di riprovare"
				},
				glare_detected: {
					message: "Rilevato riverbero",
					instruction: "Tutti i dettagli devono essere chiari e leggibili"
				},
				sms_failed: {
					message: "Qualcosa è andato storto",
					instruction: "Copia il link sul tuo telefono"
				},
				sms_overuse: {
					message: "Troppi tentativi non riusciti",
					instruction: "Copia il link sul tuo telefono"
				},
				lazy_loading: {
					message: "Si è verificato un errore durante il caricamento del componente"
				},
				invalid_number: {
					message: "Verifica che il tuo numero sia corretto"
				},
				generic_client_error: {
					message: "Qualcosa è andato storto",
					instruction: "Dovrai riavviare la verifica sul tuo computer"
				},
				forbidden_client_error: {
					message: "Qualcosa è andato storto",
					instruction: "Il link funziona solo su dispositivi mobili"
				},
				camera_not_working: {
					message: "Fotocamera non funzionante",
					instruction: "Potrebbe essere scollegata. <fallback>Prova a usare il tuo telefono</fallback>."
				},
				camera_not_working_no_fallback: {
					instruction: "Assicurati che la fotocamera del tuo dispositivo funzioni"
				},
				liveness_timeout: {
					message: "Sembra che tu ci abbia messo troppo tempo",
					instruction:
						"Ricordati di premere Stop quando hai finito. <fallback>Ripeti le azioni video</fallback>"
				},
				camera_inactive: {
					message: "La fotocamera non funziona?",
					instruction:
						"Verifica che sia collegata e funzionante. Puoi anche <fallback>continuare la verifica sul tuo telefono</fallback>"
				},
				camera_inactive_no_fallback: {
					instruction: "Assicurati che il tuo dispositivo disponga di una fotocamera funzionante"
				},
				interrupted_flow_error: {
					message: "Fotocamera non rilevata",
					instruction: "Riavvia il processo su un altro dispositivo"
				},
				unsupported_android_browser: {
					message: "Browser non supportato",
					instruction: "Riavvia il processo sull'ultima versione di Google Chrome"
				},
				unsupported_ios_browser: {
					message: "Browser non supportato",
					instruction: "Riavvia il processo sull'ultima versione di Safari"
				}
			},
			accessibility: {
				close_sdk_screen: "Chiudi la schermata di verifica dell'identità",
				dismiss_alert: "Ignora avviso",
				camera_view: "Vista dalla fotocamera",
				shutter: "Scatta una foto",
				start_recording: "Avvia la registrazione",
				stop_recording: "Interrompi la registrazione",
				replay_video: "Riproduci il tuo video registrato",
				document_types: "Documenti che puoi utilizzare per verificare la tua identità",
				selfie_video_actions: "Azioni per registrare un video selfie",
				cross_device_verification: "Procedura per proseguire con la verifica sul tuo cellulare",
				country_select: "Seleziona il paese"
			},
			passport: "Passaporto",
			driving_licence: "Patente di guida",
			national_identity_card: "Carta d'identità",
			short_passport: "passaporto",
			short_driving_licence: "patente",
			short_national_identity_card: "carta",
			bank_building_society_statement: "Dichiarazione della banca o della società di costruzione",
			utility_bill: "Bolletta",
			benefit_letters: "Lettera di prestazioni",
			government_letter: "Lettera governativa",
			council_tax: "Lettera d'imposta comunale",
			loading: "Caricamento",
			back: "Indietro",
			cancel: "Annulla",
			close: "Chiudi",
			continue: "Continua"
		}
	},
	pol: {
		locale: "pl",
		phrases: {
			welcome: {
				title: "Otwórz nowe konto bankowe",
				description_p_1: "Aby otworzyć konto bankowe, musisz zweryfikować tożsamość.",
				description_p_2: "Zajmie to tylko parę minut.",
				next_button: "Zweryfikuj tożsamość"
			},
			document_selector: {
				identity: {
					title: "Zweryfikuj tożsamość",
					hint: "Wybierz typ dokumentu tożsamości, który chcesz przesłać",
					passport_hint: "Strona ze zdjęciem twarzy",
					driving_licence_hint: "Awers i rewers",
					national_identity_card_hint: "Awers i rewers"
				},
				proof_of_address: {
					title: "Wybierz dokument z kraju %{country}",
					hint: "To są dokumenty, które najprawdopodobniej zawierają aktualny adres zamieszkania",
					estatements_accepted: "Zaakceptowane e-wyciągi",
					utility_bill_hint: "Gaz, energia elektryczna, woda, telefon stacjonarny lub łącze szerokopasmowe",
					utility_bill_warning: "Przepraszamy, nie rachunki za telefon komórkowy",
					benefits_letter_hint:
						"Świadczenia dla gospodarstw domowych przyznane przez urząd, np. zasiłek dla bezrobotnych, dodatek mieszkaniowy, ulgi podatkowe",
					government_letter_hint:
						"Dowolne pismo wydane przez urząd, np. przyznanie zasiłku, korespondencja wyborcza, pisma podatkowe itd."
				}
			},
			capture: {
				driving_licence: {
					front: {
						title: "Prześlij dokument (awers)",
						instructions: "Prześlij awers dokumentu z komputera",
						webcam: "Ustaw awers dokumentu w kadrze (zostanie automatycznie wykryty)"
					},
					back: {
						title: "Prześlij dokument (rewers)",
						instructions: "Prześlij rewers dokumentu z komputera",
						webcam: "Ustaw rewers dokumentu w kadrze (zostanie automatycznie wykryty)"
					}
				},
				national_identity_card: {
					front: {
						title: "Prześlij dowód osobisty (awers)",
						instructions: "Prześlij awers dokumentu z komputera",
						webcam: "Ustaw awers dokumentu w kadrze (zostanie automatycznie wykryty)"
					},
					back: {
						title: "Prześlij dowód osobisty (rewers)",
						instructions: "Prześlij rewers dokumentu z komputera",
						webcam: "Ustaw rewers dokumentu w kadrze (zostanie automatycznie wykryty)"
					}
				},
				passport: {
					front: {
						title: "Prześlij stronę paszportu ze zdjęciem",
						instructions: "Prześlij stronę paszportu ze zdjęciem z komputera",
						webcam: "Ustaw stronę paszportu ze zdjęciem w kadrze (zostanie automatycznie wykryty)"
					}
				},
				bank_building_society_statement: {
					front: {
						title: "Prześlij wyciąg",
						sub_title: "Musi być wydany w ciągu <strong>ostatnich 3 miesięcy</strong>",
						instructions: "W celu uzyskania najlepszych rezultatów przekaż całą stronę dokumentu",
						webcam: "Ustaw wyciąg bankowy w kadrze (zostanie automatycznie wykryty)"
					}
				},
				utility_bill: {
					front: {
						title: "Prześlij rachunek",
						sub_title: "Musi być wydany w ciągu <strong>ostatnich 3 miesięcy</strong>",
						instructions: "W celu uzyskania najlepszych rezultatów przekaż całą stronę dokumentu",
						webcam: "Ustaw rachunek za media w kadrze (zostanie automatycznie wykryty)"
					}
				},
				benefit_letters: {
					front: {
						title: "Prześlij pismo",
						sub_title: "Musi być wydany w ciągu <strong>ostatnich 12 miesięcy</strong>",
						instructions: "W celu uzyskania najlepszych rezultatów przekaż całą stronę dokumentu",
						webcam: "Ustaw pismo w sprawie świadczeń w kadrze (zostanie automatycznie wykryty)"
					}
				},
				council_tax: {
					front: {
						title: "Prześlij pismo",
						sub_title: "Musi być wydany w ciągu <strong>ostatnich 12 miesięcy</strong>",
						instructions: "W celu uzyskania najlepszych rezultatów przekaż całą stronę dokumentu",
						webcam: "Ustaw pismo w sprawie podatku od nieruchomości w kadrze (zostanie automatycznie wykryty)"
					}
				},
				government_letter: {
					front: {
						title: "Pismo urzędowe",
						sub_title: "Musi być wydany w ciągu <strong>ostatnich 12 miesięcy</strong>",
						instructions: "W celu uzyskania najlepszych rezultatów przekaż całą stronę dokumentu",
						webcam: "Ustaw pismo urzędowe w kadrze (zostanie automatycznie wykryty)"
					}
				},
				face: {
					title: "Wykonaj autoportret",
					upload_title: "Autoportret",
					instructions: "Prześlij autoportret z komputera",
					intro: {
						title: "Wykonaj autoportret",
						subtitle: "Porównamy je z dokumentem",
						selfie_instruction:
							"Ustaw się przodem do obiektywu i upewnij się, że oczy są wyraźnie widoczne",
						glasses_instruction: "Zdejmij okulary w razie potrzeby",
						accessibility: {
							selfie_capture_tips: "Wskazówki dotyczące wykonywania dobrych autoportretów"
						}
					}
				},
				liveness: {
					start: "Rozpocznij",
					stop: "Zatrzymaj",
					recording: "Nagranie",
					press_record: "Naciśnij przycisk nagrywania i postępuj zgodnie z instrukcjami",
					intro: {
						title: "Upewnijmy się, że nikt nie podszywa się",
						two_actions:
							"Poprosimy o nagranie siebie podczas wykonywania <strong>2 prostych czynności</strong>",
						speak_out_loud: "Pierwsza będzie wymagać <strong>głośnego mówienia</strong>",
						continue: "Kontynuuj"
					},
					challenges: {
						position_face: "Ustaw twarz w owalu",
						recite: "Wypowiedz głośno każdą cyfrę",
						movement: "Popatrz w %{side} przez ramię",
						right: "prawo",
						left: "lewo",
						done_next: "Gdy skończysz, naciśnij przycisk dalej",
						done_stop: "Gdy skończysz, naciśnij przycisk zatrzymaj",
						next: "Dalej"
					}
				},
				upload_document: "Prześlij",
				upload_file: "lub prześlij zdjęcie – żadnych skanów i kser",
				take_photo: "Wykonaj zdjęcie",
				switch_device: "Kontynuuj na telefonie"
			},
			confirm: {
				document: {
					title: "Sprawdź czytelność",
					alt: "Zdjęcie dokumentu"
				},
				driving_licence: {
					message: "Upewnij się, że dane dokumentu są czytelne, bez rozmycia lub odblasku"
				},
				national_identity_card: {
					message: "Upewnij się, że dane dokumentu są czytelne, bez rozmycia lub odblasku"
				},
				passport: {
					message: "Upewnij się, że dane paszportu są czytelne, bez rozmycia lub odblasku"
				},
				bank_building_society_statement: {
					message: "Upewnij się, że dane są czytelne, bez rozmycia lub odblasku"
				},
				utility_bill: {
					message: "Upewnij się, że dane są czytelne, bez rozmycia lub odblasku"
				},
				benefit_letters: {
					message: "Upewnij się, że dane są czytelne, bez rozmycia lub odblasku"
				},
				council_tax: {
					message: "Upewnij się, że dane są czytelne, bez rozmycia lub odblasku"
				},
				face: {
					standard: {
						title: "Sprawdź autoportret",
						message: "Upewnij się, że na autoportrecie wyraźnie widać twarz",
						alt: "Zdjęcie twarzy"
					},
					video: {
						title: "Sprawdź film autoportretowy"
					}
				},
				confirm: "Potwierdź",
				continue: "Kontynuuj",
				redo: "Ponów",
				enlarge_image: {
					enlarge: "Powiększ obraz",
					close: "Zamknij"
				}
			},
			complete: {
				message: "Weryfikacja zakończona",
				submessage:
					"Twoja weryfikacja jest obecnie przetwarzana. Wyślemy Ci wiadomość e-mail po jej zatwierdzeniu"
			},
			cross_device: {
				intro: {
					title: "Kontynuuj na telefonie",
					sub_title: "Oto, jak to zrobić:",
					description_li_1: "Wyślij zabezpieczone łącze na telefon",
					description_li_2: "Otwórz łącze i wykonaj zadania",
					description_li_3: "Wróć tutaj, aby dokończyć zgłoszenie",
					action: "Uzyskaj zabezpieczone łącze"
				},
				client_success: {
					title: "Uploads successful",
					sub_title: "You can now return to your computer to continue",
					body: "Komputer może potrzebować kilku sekund na aktualizację"
				},
				link: {
					title: "Uzyskaj zabezpieczone łącze",
					qr_code_sub_title: "Zeskanuj kod QR przy użyciu telefonu",
					sms_sub_title: "Wyślij jednorazowe łącze na telefon",
					copy_link_sub_title: "Otwórz łącze na telefonie",
					options_divider_label: "lub",
					sms_option: "Uzyskaj łącze przez SMS",
					copy_link_option: "Kopiuj łącze",
					qr_code_option: "Zeskanuj kod QR",
					copy_link: {
						action: "Kopiuj",
						success: "Skopiowano"
					},
					button_copy: {
						action: "Send link",
						status: "Wysyłanie"
					},
					qr_code: {
						help_label: "Jak zeskanować kod QR",
						help_step_1: "Wyceluj aparat telefonu w kod QR",
						help_step_2: "Jeśli nie działa, pobierz skaner kodów QR z Google Play lub App Store"
					},
					sms_label: "Wprowadź numer telefonu:",
					copy_link_label: "Skopiuj łącze do przeglądarki w telefonie"
				},
				submit: {
					title: "Doskonale, to wszystko, czego potrzebujemy",
					sub_title: "Jesteśmy gotowi do weryfikacji tożsamości",
					selfie_uploaded: "Autoportret przesłany",
					video_uploaded: "Film przesłany",
					action: "Prześlij weryfikację",
					multiple_docs_uploaded: "Dokumenty przesłane",
					one_doc_uploaded: "Dokument przesłany"
				},
				phone_number_placeholder: "Wprowadź numer telefonu",
				loading: "Ładowanie...",
				mobile_connected: {
					title: {
						message: "Połączono z telefonem",
						submessage: "Gdy skończysz, przejdziemy do następnego kroku"
					},
					tips: {
						item_1: "Zostaw to okno otwarte podczas używania telefonu",
						item_2: "Łącze na telefon wygaśnie w ciągu godziny",
						item_3: "Nie odświeżaj tej strony"
					}
				},
				mobile_notification_sent: {
					title: "Sprawdź telefon",
					submessage: "Wysłaliśmy zabezpieczone łącze pod numer %{number}",
					bold_message: "Zostanie dostarczone w ciągu kilku minut",
					tips: {
						item_1: "Zostaw to okno otwarte podczas używania telefonu",
						item_2: "Łącze wygaśnie w ciągu godziny"
					},
					resend_link: "Wyślij ponownie łącze"
				},
				switch_device: {
					header: "Wykonaj zdjęcie przy użyciu telefonu"
				},
				tips: "Wskazówki"
			},
			webcam_permissions: {
				allow_access: "Zezwól na dostęp do aparatu",
				enable_webcam_for_selfie:
					"W razie wyświetlenia monitu należy zezwolić na dostęp do aparatu, aby kontynuować",
				click_allow: "Nie możemy dokonać weryfikacji bez użycia aparatu",
				allow: "Zezwól",
				why: "Dlaczego muszę to zrobić?",
				if_denied:
					"Jeśli nie zezwolisz na dostęp do aparatu, nie będzie możliwe wykonanie zdjęć i dokończenie procesu weryfikacji.",
				enable_webcam: "Włącz aparat",
				access_denied: "Brak zezwolenia na dostęp do aparatu",
				recover_access: "Odzyskaj dostęp do aparatu, aby kontynuować weryfikację twarzy",
				recovery: "Odzyskiwanie",
				follow_steps: "Wykonaj te kroki, aby odzyskać dostęp do aparatu:",
				grant_access: "Przyznaj dostęp do aparatu w ustawieniach przeglądarki",
				refresh_page: "Odśwież tę stronę, aby uruchomić ponownie proces weryfikacji tożsamości",
				refresh: "Odśwież"
			},
			proof_of_address: {
				intro: {
					title: "Zweryfikujmy adres w kraju %{country}",
					requirements: "Potrzebny będzie dokument, który:",
					shows_address: "Podaje <strong>aktualny</strong> adres",
					matches_signup: "Jest <strong>zgodny</strong> z adresem użytym przy rejestracji",
					is_recent: "Jest najbardziej <strong>aktualnym</strong> dokumentem",
					start: "Rozpocznij weryfikację"
				},
				guidance: {
					logo: "Logo",
					full_name: "Imię i nazwisko",
					make_sure_it_shows: "Upewnij się, że podaje wyraźnie:",
					current_address: "Aktualny adres",
					issue_date: "Data wydania lub okres podsumowania",
					continue: "Kontynuuj"
				}
			},
			errors: {
				invalid_capture: {
					message: "No document detected",
					instruction: "Upewnij się, że cały dokument jest na zdjęciu"
				},
				invalid_type: {
					message: "Plik nie został przesłany.",
					instruction: "Spróbuj użyć innego typu pliku."
				},
				unsupported_file: {
					message: "Typ pliku nie jest obsługiwany",
					instruction: "Spróbuj użyć pliku JPG lub PNG"
				},
				invalid_size: {
					message: "Rozmiar pliku został przekroczony.",
					instruction: "Musi wynosić poniżej 10 MB."
				},
				no_face: {
					message: "Nie znaleziono twarzy",
					instruction: "Twarz musi być na autoportrecie"
				},
				multiple_faces: {
					message: "Znaleziono wiele twarzy",
					instruction: "Tylko twarz użytkownika może być na autoportrecie"
				},
				server_error: {
					message: "Utracono połączenie",
					instruction: "Spróbuj ponownie"
				},
				glare_detected: {
					message: "Wykryto odblask",
					instruction: "Wszystkie szczegóły powinny być wyraźne i czytelne"
				},
				sms_failed: {
					message: "Wystąpił błąd",
					instruction: "Skopiuj łącze do telefonu"
				},
				sms_overuse: {
					message: "Zbyt wiele nieudanych prób",
					instruction: "Skopiuj łącze do telefonu"
				},
				lazy_loading: {
					message: "Wystąpił błąd podczas ładowania elementu"
				},
				invalid_number: {
					message: "Sprawdź, czy numer jest prawidłowy"
				},
				generic_client_error: {
					message: "Wystąpił błąd",
					instruction: "Potrzebne będzie uruchomienie ponowne weryfikacji na komputerze"
				},
				forbidden_client_error: {
					message: "Wystąpił błąd",
					instruction: "Łącze działa tylko na urządzeniach mobilnych"
				},
				camera_not_working: {
					message: "Aparat nie działa",
					instruction: "Może być rozłączony. <fallback>Spróbuj użyć telefonu</fallback>."
				},
				camera_not_working_no_fallback: {
					instruction: "Upewnij się, że aparat urządzenia działa"
				},
				liveness_timeout: {
					message: "Wygląda na to, że działanie trwało zbyt długo",
					instruction:
						"Pamiętaj, aby nacisnąć przycisk zatrzymaj, gdy skończysz. <fallback>Powtórz działania na filmie</fallback>"
				},
				camera_inactive: {
					message: "Aparat nie działa?",
					instruction:
						"Sprawdź, czy jest podłączony i działa. Możesz także <fallback>kontynuować weryfikację na telefonie</fallback>"
				},
				camera_inactive_no_fallback: {
					instruction: "Upewnij się, że urządzenie ma działający aparat"
				},
				interrupted_flow_error: {
					message: "Nie wykryto aparatu",
					instruction: "Uruchom ponownie proces na innym urządzeniu"
				},
				unsupported_android_browser: {
					message: "Brak obsługi przeglądarki",
					instruction: "Uruchom ponownie proces w najnowszej wersji Google Chrome"
				},
				unsupported_ios_browser: {
					message: "Brak obsługi przeglądarki",
					instruction: "Uruchom ponownie proces w najnowszej wersji Safari"
				}
			},
			accessibility: {
				close_sdk_screen: "Zamknij ekran weryfikacji tożsamości",
				dismiss_alert: "Zamknij alarm",
				camera_view: "Widok z aparatu",
				shutter: "Wykonaj zdjęcie",
				start_recording: "Rozpocznij nagrywanie",
				stop_recording: "Zatrzymaj nagrywanie",
				replay_video: "Powtórz nagrany film",
				document_types: "Dokumenty, których możesz użyć do weryfikacji tożsamości",
				selfie_video_actions: "Działania wymagane do nagrania filmu autoportretowego",
				cross_device_verification: "Kroki wymagane do kontynuacji weryfikacji na telefonie",
				country_select: "Wybierz kraj"
			},
			passport: "Paszport",
			driving_licence: "Prawo jazdy",
			national_identity_card: "Dowód osobisty",
			short_passport: "paszport",
			short_driving_licence: "dokument",
			short_national_identity_card: "dokument",
			bank_building_society_statement: "Wyciąg bankowy lub towarzystwa budowlanego",
			utility_bill: "Rachunek za media",
			benefit_letters: "Pismo w sprawie świadczeń",
			government_letter: "Pismo urzędowe",
			council_tax: "Pismo w sprawie podatku od nieruchomości",
			loading: "Ładowanie",
			back: "wstecz",
			cancel: "Anuluj",
			close: "zamknij",
			continue: "Kontynuuj"
		}
	}
};
